import {h, Fragment} from "preact"
import { useAppStateSelector, useSort, pick } from "@nosto/preact"
import { sortOptions } from "../config"
import {Icon, Select} from "./elements"
import { toggleButtonId } from "./Sidebar"

export default function ActionToolbar() {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )

    const docCount = response.products?.total ?? 0

    const totalSummary = `${docCount} results`;

    const { activeSort, setSort } = useSort(sortOptions)

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    return (
        <>
            <div id="searchspring-toolbar-header" class="facets facets-vertical-sort small-hide medium-hide">
                <div class="facets-vertical-form page-width" id="FacetSortForm">
                    <label id="HideFilters" for={toggleButtonId} class="font-primary heading-2-md">
                        <Icon name="sliders" />
                        Hide Filter
                    </label>
                    <div class="facet-filters sorting">
                        <div class="product-count-vertical" role="status">
                            <h2 class="product-count__text">
                                <span id="ProductCountDesktop" class="font-secondary mono-md">
                                    {totalSummary}
                                </span>
                            </h2>
                        </div>
                        <div class="facet-filters__field">
                            <div class="select">
                                <Icon name="sort-big" />
                                <label for="SortBy" class="facet-filters__label font-primary heading-2-md">
                                    Sort
                                </label>
                                <Select
                                    value={activeSort}
                                    onChange={e => handleSortChange(e)}
                                    options={options}
                                    label={"Sort by"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="facets-container ss__facets__container__mobile">
                <div class="product-count light large-up-hide" role="status">
                    <h2 class="product-count__text font-secondary mono-md">
                        <span id="ProductCount">{totalSummary}</span>
                    </h2>
                </div>
                <div class="mobile-facets__wrapper large-up-hide" data-breakpoint="mobile">
                    <div class="mobile-facets__disclosure disclosure-has-popup">
                        <label for={toggleButtonId} class="mobile-facets__open-wrapper focus-offset">
                            <span role="button" class="mobile-facets__open-button font-primary heading-2-md">
                                <Icon name="sliders" />
                                Filter &amp; Sort
                            </span>
                        </label>
                    </div>
                </div>
            </div>
        </>
    )
}